import { toastUpdate } from "./toast"

enum EFields {
    amount = "Preencha o Valor",
    installments ="Preencha o Número de Parcelas",
    title = "Preencha o Título da Cobrança",
    description = "Preencha a Descrição",
    dateForNextPayment = "Preencha a Data da Próxima Cobrança",
    value = "Preencha o Valor",
    phoneNumber = "Preencha o Telefone",
    cardName = "Preencha o Nome no Cartão",
    cardNumber ="Preencha o Número do Cartão",
    expirationDate = "Preencha a Expiração" ,
    cvv = "Preencha o CVV",
    order ="Preencha Ref. Pedido / Compra",
    dueDate = "Preencha a Data de Vencimento",
    instructions = "Preencha as Instruções Corpo do Boleto",
    name = "Preencha o Nome",
    frequency = "Selecione a Frequência",
    interval = "Preencha o Intervalo",
    gracePeriod = "Preencha o Período de Carência",
    setupAmount = "Preencha o Valor do Setup",
    tolerancePeriod = "Preencha a Tolerância na Falha",
    duration = "Preencha Duração do Plano",
    firstName = "Preencha o Primeiro Nome",
    lastName = "Preencha o Último Nome",
    email = "Preencha o Email",
    phone = "Preencha o Telefone",
    document = "Preencha o CNPJ",
    cpf = "Preencha o CPF",
    cep = "Preencha o CEP",
    city = "Preencha a Cidade",
    uf = "Preencha a UF",
    address = "Preencha o Endereço",
    district = "Preencha o Bairro",
    number = "Preencha o Número",
    cardValidity = "Preencha Expiração",
    nameOnCard = "Preencha nome como no cartão"
}

export const notifysFieldsForm = (err: any,errorOnSubmit: boolean) => {
    return errorOnSubmit ? Object.keys(err).reduce((previousValue: any, currentValue: any) => {
        return !err[currentValue]
        ? previousValue 
        : toastUpdate("btnSubmit","warning",3000, `${EFields[currentValue as keyof typeof EFields]}` )
    }, "") : null
}